import React from 'react';
import { useInView } from 'framer-motion';
import { useEffect, useRef } from 'react';
import Utils from '../../../../utils/Utils';

type VideoWrapperProps = {
  className?: string;
};

export const VideoWrapper: React.FC<VideoWrapperProps> = ({ className }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-120px' });
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (isInView) {
      videoRef.current?.play().catch(() => {
        console.log('Video play was prevented');
      });
    }
  }, [isInView]);

  return (
    <div
      ref={ref}
      className={Utils.cn(
        'w-full max-w-[576px] h-[587px] rounded-[20px] border border-[#F9F5FF] overflow-hidden bg-[#eef1ff] relative',
        className,
      )}>
      <video
        ref={videoRef}
        src="/videos/ai-career-preview.mp4"
        muted
        loop
        playsInline
        preload="metadata"
        className="w-full h-full object-cover scale-110 origin-center"
      />
    </div>
  );
};
